module.exports = __webpack_public_path__ + "b211d17420cd9661c4f107e5f8348d2c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/earrings-pearl-s.png
// module id = 2666
// module chunks = 0